import {
  LoginActionConst,
  SignUpActionConst,
  ClearSignUpFieldsActionConst,
  GetLandlordProfileActionConst,
  ProfileCompletedActionConst,
  SendProfileForApprovalActionConst,
  LogoutActionConst,
  HydrateActionConst,
} from "../../constants/authActionConst";
import BaseUrl from "../../../constants/BaseUrl";
import { ShowSuccess } from "../../../utils/ToasFunction";
import {
  getStoredLoginData,
  getStoredUserCredentials,
  saveLoginData,
  saveUserCredentials,
  clearAuthData,
  clearUserCredentials,
} from "../../../utils/storageUtils";

export const UserLogInAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: LoginActionConst.USER_LOGIN_REQUEST,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}superAdmin/auth/signIn`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          // Save login data to localStorage immediately upon successful login
          saveLoginData(result);

          dispatch({
            type: LoginActionConst.USER_LOGIN_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: LoginActionConst.USER_LOGIN_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const ClearSignUpFieldsAction = () => {
  return async (dispatch) => {
    dispatch({
      type: ClearSignUpFieldsActionConst.SIGNUP_CLEAR,
    });
  };
};

export const LogoutAction = () => {
  return async (dispatch) => {
    // Clear all auth data from localStorage
    clearAuthData();

    dispatch({
      type: LogoutActionConst.LOGOUT_ACTION,
    });
  };
};

export const GetLandlordProfile = (userId, loginSuccess) => {
  return async (dispatch) => {
    dispatch({
      type: GetLandlordProfileActionConst.GET_USER_PROFILE_REQ,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/getProfileDetails/${userId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: GetLandlordProfileActionConst.GET_USER_PROFILE_SUCCESS,
            result: result.data,
          });
        } else {
          // alert("ERROR=", JSON.stringify(result))
          dispatch({
            type: GetLandlordProfileActionConst.GET_USER_PROFILE_FAIL,
            result: result.message,
          });
        }
      })
      .catch((error) => console.error(error));

    return;
  };
};

export const UserSignUpAction = (fields) => {
  return async (dispatch) => {
    dispatch({
      type: SignUpActionConst.USER_SIGNUP_REQUEST,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      firstName: fields.firstName,
      lastName: fields.lastName,
      email: fields.email,
      password: fields.password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/auth/signUp`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          dispatch({
            type: SignUpActionConst.USER_SIGNUP_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: SignUpActionConst.USER_SIGNUP_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const SendProfileForApprovalAction = (id) => {
  return async (dispatch) => {
    dispatch({
      type: SendProfileForApprovalActionConst.SEND_REQUEST_FOR_APPROVAL_REQ,
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      recordId: id,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}landlord/profile/sendProfileRequestForApproval`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          ShowSuccess("Request send for approval");
          dispatch({
            type: SendProfileForApprovalActionConst.SEND_REQUEST_FOR_APPROVAL_SUCC,
          });
        } else {
          dispatch({
            type: SendProfileForApprovalActionConst.SEND_REQUEST_FOR_APPROVAL_FAIL,
          });
        }
      })
      .catch((error) => console.error(error));
  };
};

export const HydrateStateAction = () => {
  return async (dispatch) => {
    dispatch({
      type: HydrateActionConst.HYDRATE_STATE_REQUEST,
    });

    try {
      const loginData = getStoredLoginData();
      const userCredentials = getStoredUserCredentials();

      dispatch({
        type: HydrateActionConst.HYDRATE_STATE_SUCCESS,
        result: {
          loginData,
          userCredentials,
        },
      });
    } catch (error) {
      console.error("Error hydrating state:", error);
      dispatch({
        type: HydrateActionConst.HYDRATE_STATE_FAIL,
        result: error.message,
      });
    }
  };
};
